/*
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Système de template
 */
/* global FB */

(function($g, $) {
    "use strict";

    function encodeEntities(rawStr) {
        var encodedStr = rawStr.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
            return '&#' + i.charCodeAt(0) + ';';
        });
        return encodedStr;
    }

    function replace(txt, key, value) {
        var v=value?value.toString():"";
        var encoded = encodeEntities(v);
        return txt.split(key).join(encoded);
    }

    function replaceCurly(txt, key, value) {
        return replace(txt, "{"+key+"}", value);
    }

    function replacePct(txt, key, value) {
        return replace(txt, "%"+key+"%", value);
    }

    function replaceNumber(template, value) {
        value=value|0;
        var parts = template.split("|");
        var str;
        if (parts.length===3) {
            if (value===0) {
                str=parts[0].substr(3);
            } else if (value===1) {
                str=parts[1].substr(3);
            } else {
                str=parts[2];
            }
        } else {
            str=template;
        }
        var b = str.indexOf("[");
        if (b>0) {
            str=str.substr(b+1);
        }
        str = str.trim();
        return replacePct(str, "count", value.toString());
    }

    function replaceAll(txt, args, prefix) {
        prefix=prefix||"";
        for (var k in args) {
            var v = args[k];
            var t = typeof v;
            if (t === "string" || t === "number") {
                txt = replaceCurly(txt, prefix+k, v);
            } else {
                txt = replaceAll(txt, v, prefix+k+".");
            }
        }
        return txt;
    }

    function Template(behavior) {
        var me = this;
        var items = {};
        this.vars = {};

        /**
         * Obtenir le contenu du template brute
         * @param {string} id
         * @param {object} replaceMap paramètres à remplacer
         * @returns {string}
         */
        this.get = function(id, replaceMap) {
            var item = items[id];
            var data = item.data;
            return replaceMap?replaceAll(data,replaceMap):data;
        };

        /**
         * Add a resource
         * @param key string
         * @param data string
         * @param type string    html | text, default is text
         * @return undefined
         */
        this.add = function(key, data, type) {
            items[key] = {
                data: data,
                type: type
            };
        };

        /**
         * Import resource from an xml
         * @return undefined
         */
        this.read = function(xml) {
            var $xml = $(xml);
            var $childs = $xml.children().children();
            for (var i = 0; i < $childs.length; i++) {
                var $it = $($childs[i]);
                var key = $it.attr("key");
                var type = $it.attr("type");
                var data = (type==="text") ? $it.text() : $g.html($it);
                me.add(key, data, type);
            }
        };

        function copyArrib($source, $dest) {
            var attributes = $source[0].attributes;
            for (var i = 0; i < attributes.length; i++) {
                var a = attributes[i];
                var n = a.name;
                var v = a.value;
                if (n === "class") {
                    $dest.addClass(a.value);
                } else if (n === "style") {

                } else {
                    $dest.attr(n, v);
                }
            }
        }

        this.inject = function($ct, id, replaceMap, options) {
            options=options||{};
            function cond() {
                var $v = $(this);
                if (!replaceMap[$v.attr("data-cond")]) {
                    $v.remove();
                }
            }

            var data = me.get(id);
            var replaced = replaceAll(data, replaceMap);
            var $div = $("<root>" + replaced + "</root>");

            $div.find("[data-cond]").each(cond);
            $div = $div.children();
            if (!options.noBehavior) {
                behavior.attach($div);
            }
            if (options.prepend) {
                $ct.prepend($div);
            } else if (options.after) {
                $ct.after($div);
            } else if (options.replace) {
                $ct.replaceWith($div);
            } else if (options.inner) {
                $ct.empty().append($div.children());
                copyArrib($div, $ct);
                return $ct;
            } else {
                $ct.append($div);
            }
            return $div;
        };

        this.remove = function($dom) {
            behavior.detach($dom);
            $dom.remove();
        };

    }

    function load() {
        var args = arguments;
        var tmp = new Template($g.behavior);
        var nb = 0;
        var l = args.length;
        var data = [];
        function complete() {
            for (var i =0; i < l; i++) {
                tmp.read(data[i]);
            }
            $g.template=tmp;
        }
        function loadi(i) {
            $.get(args[i], {}, function(xml) {
                data[i] = xml;
                nb++;
                if (nb===l) {
                    complete();
                }
            });
        }
        function loadAll() {
            for (var i = 0; i < l; i++) {
                loadi(i);
            }
        }
        loadAll();
    }

    Template.encodeEntities = encodeEntities;
    Template.replace = replace;
    Template.replaceAll = replaceAll;
//    Template.replaceAll = replaceAll;
    Template.replaceNumber = replaceNumber;
    Template.load = load;

    $g.Template = Template;

})(PVPGEngine, jQuery);
